import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=57c9ecf0&"
import script from "./submenu.vue?vue&type=script&lang=js&"
export * from "./submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports